export default __webpack_public_path__ + "static/media/gitfront.23eee698.svg";